import { EAppStep } from '@/typescript/enums/EAppStep';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { IFont } from '@/typescript/interfaces/IFont';

const useConfigStore = defineStore('config', () => {
    const isMobile = ref(false);
    const isAppLoading = ref(true);
    const currentStep = ref(EAppStep.TEMPLATES);
    const fonts = ref<IFont[]>([]);
    const token = ref('');
    const userName = ref('');
    const isAdmin = ref(false);
    const isAnimated = ref(false);
    const isZoomed = ref(true);
    const prestashopUserId = ref<number>();
    const showAspectSelector = ref(false);
    const fZoom = ref(1);
    const lang = ref<'fr_FR' | 'en_EN'>('fr_FR');
    const uniqueId = ref('');
    const isPollOpen = ref(false);
    const displayBatImage = ref(false);

    return {
        isMobile,
        isAppLoading,
        currentStep,
        fonts,
        token,
        userName,
        isAdmin,
        isAnimated,
        isZoomed,
        prestashopUserId,
        showAspectSelector,
        fZoom,
        lang,
        uniqueId,
        isPollOpen,
        displayBatImage,
    };
});

export default useConfigStore;
